import React from 'react'
import Spinner from 'app/components/Spinner/Spinner'
import { withTranslation } from 'react-i18next'

const GalleryLoader = ({ t }) => (
  <div className="gallery-loader">
    <Spinner title={t('Loading Gallery')} transparent />
  </div>
)

GalleryLoader.displayName = 'GalleryLoader'

export default withTranslation()(GalleryLoader)
